import React from 'react';
import {FormGroup, Label, Input} from 'reactstrap';

interface DiscEditorProps {
    radius: number;
    tessellation?: number | null;
    onChange: (radius: number) => void;
    onTessellationChange: (tessellation: number | null) => void;
}

const DiscEditor: React.FC<DiscEditorProps> = ({
    radius,
    tessellation,
    onChange,
    onTessellationChange
}) => {
    const handleRadiusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value);
        onChange(isNaN(value) ? 0 : value);
    };

    const handleTessellationChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = parseInt(e.target.value, 10);
        onTessellationChange(isNaN(value) ? null : value);
    };

    return (
        <>
            <FormGroup>
                <Label>Radius:</Label>
                <Input
                    type="number"
                    step="0.1"
                    value={radius}
                    onChange={handleRadiusChange}
                />
            </FormGroup>
            <FormGroup>
                <Label>Sides:</Label>
                <Input
                    type="number"
                    step="1"
                    min="3"
                    value={tessellation ?? ''}
                    placeholder="64"
                    onChange={handleTessellationChange}
                />
            </FormGroup>
        </>
    );
};

export default DiscEditor;
